export default __webpack_public_path__ + "static/media/Safe.39c3a0f5.png";